import { combineReducers } from 'redux';
import * as types from '../constants';

const ids = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_USERS_SUCCESS:
      return action.payload.rows.result;
    case types.SAVE_USER_SUCCESS:
      return [...state, action.response.result];
    case types.DELETE_USER_SUCCESS:
      return state.filter(userId => userId !== action.payload);
    default:
      return state;
  }
};

const brand = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_BRAND_USERS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};

const staffMembers = (state = [], action) => {
  switch (action.type) {
    case types.RESET_BRAND_STAFF_USERS:
      return [];
    case types.FETCH_BRAND_STAFF_USERS:
      return [];
    case types.FETCH_BRAND_STAFF_USERS_SUCCESS:
      return action.users;
    default:
      return state;
  }
};

export default combineReducers({
  ids,
  brand,
  staffMembers,
});
